import { Images } from 'assets/images';
import { useEffect, useState } from 'react';
import {
  Counter,
  CounterContainer,
  CountValue,
  MinusCount,
  PlusCount,
  QuestionText,
} from './styled';

export const CounterStep = ({
  currentQuestion,
  generateAnswersObject,
  answerItem,
}) => {
  const [count, setCount] = useState(0);

  const MinusCounter = () => {
    if (count > 0) {
      setCount(count - 1);
      generateAnswersObject({
        position: currentQuestion.position,
        question: currentQuestion.question,
        selectedAnswers: [count - 1],
      });
    }
  };

  const PlusCounter = () => {
    if (count < 100) {
      setCount(count + 1);
      generateAnswersObject({
        position: currentQuestion.position,
        question: currentQuestion.question,
        selectedAnswers: [count + 1],
      });
    }
  };

  useEffect(() => {
    if (answerItem?.selectedAnswers?.length) {
      setCount(answerItem?.selectedAnswers[0]);
    } else {
      generateAnswersObject({
        position: currentQuestion.position,
        question: currentQuestion.question,
        selectedAnswers: [0],
      });
      setCount(0);
    }
  }, [currentQuestion?.position]);

  return (
    <CounterContainer>
      <QuestionText> {currentQuestion.question} </QuestionText>
      <Counter>
        <MinusCount src={Images.minusIcon} onClick={MinusCounter} />
        <CountValue>{count}</CountValue>
        <PlusCount src={Images.plusIcon} onClick={PlusCounter} />
      </Counter>
    </CounterContainer>
  );
};
